import * as React from "react";
import PropTypes from 'prop-types';

const SvgClose = props => {
  if (props.id !== "_svgclose") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path d="M14 14l20 20m-20 0l20-20" stroke="#384048" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
};

SvgClose.displayName = "_svgclose";
SvgClose.propTypes = {
  id: PropTypes.string
};
SvgClose.defaultProps = {
  id: ''
};
export default SvgClose;